
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import ImageUploader from "../ImageUploader";
import TagSelector from "../TagSelector";
import { ArticleAuthor, ArticleTag } from "@/types/article-types";

interface MetadataTabSectionProps {
  headerImageUrl?: string;
  handleHeaderImageUpload: (file: File) => Promise<void>;
  clearHeaderImage: () => void;
  authorId?: string;
  setAuthorId: (value: string) => void;
  authors: ArticleAuthor[];
  selectedTags: string[];
  setSelectedTags: (tags: string[]) => void;
  tags: ArticleTag[];
  createArticleTag: (name: string) => Promise<ArticleTag | null>;
  formErrors: Record<string, string>;
}

const MetadataTabSection = ({
  headerImageUrl,
  handleHeaderImageUpload,
  clearHeaderImage,
  authorId,
  setAuthorId,
  authors,
  selectedTags,
  setSelectedTags,
  tags,
  createArticleTag,
  formErrors
}: MetadataTabSectionProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Header Image</Label>
        <ImageUploader
          currentImageUrl={headerImageUrl}
          onUpload={handleHeaderImageUpload}
          onClear={clearHeaderImage}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="author">Author</Label>
        <Select 
          value={authorId} 
          onValueChange={setAuthorId}
        >
          <SelectTrigger className={formErrors.authorId ? "border-red-500" : ""}>
            <SelectValue placeholder="Select author" />
          </SelectTrigger>
          <SelectContent>
            {authors && authors.length > 0 ? (
              authors.map((author) => (
                <SelectItem key={author.id} value={author.id}>
                  {author.first_name} {author.last_name || ''}
                </SelectItem>
              ))
            ) : (
              <SelectItem value="loading" disabled>
                No authors available
              </SelectItem>
            )}
          </SelectContent>
        </Select>
        {formErrors.authorId && (
          <p className="text-red-500 text-sm">{formErrors.authorId}</p>
        )}
      </div>
      
      <div className="space-y-2">
        <Label>Tags</Label>
        <TagSelector
          availableTags={tags}
          selectedTags={selectedTags}
          onChange={setSelectedTags}
          onCreateTag={createArticleTag}
        />
      </div>
    </div>
  );
};

export default MetadataTabSection;
